import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Rx";
import { Subscription } from "rxjs/Subscription";
import * as _ from "lodash";

import * as stageTypes from "../../types";
import * as animations from "../../../shared/animations";
import * as commonTypes from "../../../shared/types";

import { StageSandbox } from "../../services/stage.sandbox";
import { IApplicationState } from "../../../stateManagement/states/applicationState";
import { IDynamicData } from "../../../shared/types/dynamicData";
import { QUESTION_TYPES, BUTTON_TYPES, TASK_STATUS, TASK_STATUS_BUTTON } from "../../types/constants";

@Component({
  selector: "tr-tasks-container",
  animations: [animations.fadeInUpAnimation],
  templateUrl: "./tasks-container.component.html",
  styleUrls: ['./tasks-container.component.scss']
})
export class TasksContainerComponent implements OnInit, OnDestroy {
  @Input() entity: stageTypes.IPage;
  // @Output() buttonClick= new EventEmitter;

  private isSubmitted: boolean = false;
  private subscriptions: Array<Subscription> = [];
  private htmlContents: stageTypes.IPageDef[];
  private taskList: any;
  private attachmentContents: stageTypes.IPageDef[] = [];
  private allAttachmentsDownloaded$: Observable<
    boolean
  > = this.sb.getAllAttachmentsDownloadingStatus$();
  private queryOfferMessage: string = "";
  // TODO: remove in real business logic
  private updatedStageId: number;
  public type: string ;
  public typeid: number;

  constructor(private sb: StageSandbox, private route: ActivatedRoute, private router:Router) {
    this.type = this.sb.getType();
    this.typeid = this.sb.getTypeID();
  }

  ngOnInit() {
    this.htmlContents = this.entity.fields.filter(
      (field: stageTypes.IPageDef) => field.type === QUESTION_TYPES.HTML_CONTENT
    );

    this.taskList = this.entity.tasks.filter(
      (field: stageTypes.ITasksDef) => field.widget === QUESTION_TYPES.TASK_LIST
    );
  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getType() {
    return this.type;
  }

  getStatusText(status: string) : string {
    return TASK_STATUS[status] ;
  }

  getStatusButton(status: string) : string {
    return TASK_STATUS_BUTTON[status] ;
  }

  onButtonClicked(taskid: number): void {
    var url = this.router.createUrlTree(['task', taskid], {relativeTo: this.route}).toString();
    this.router.navigate([url]);
  }
}


// WEBPACK FOOTER //
// ./src/app/stage/containers/tasks-container/tasks-container.component.ts